import React from 'react'
import { NamedRoutes } from '../../../../routes'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { ExternalEntityGroupProvider } from '../../../../ExternalEntityGroupContext'
import { FormattedMessage, useIntl } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { SEO } from '../../../../components/Seo/seo'
import ExternalEntityGroupEditContent from '../../../../components/Dashboard/Subscription/ExternalEntityGroupEditContent'
import { Redirect } from 'react-router-dom'
import { externalEntityGroups } from '../../../../utils/pages-meta.json'

const SingleExternalEntityGroupAdd = () => {

  const intl = useIntl()

  return (
    <>
      <SEO title={intl.formatMessage({ id: 'ExternalEntityGroups.List.AddExternalEntityGroup.Title' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={externalEntityGroups.image}
        description={intl.formatMessage({ id: 'ExternalEntityGroups.List.AddExternalEntityGroup.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length &&
              <>
                {!!userData.is_admin ?
                  <Layout content={
                    <ExternalEntityGroupProvider handleNotificationCall={handleNotificationCall}>
                      <ExternalEntityGroupEditContent
                        pageTitle={<FormattedMessage id='ExternalEntityGroups.List.AddExternalEntityGroup.Title' />}
                        handleNotificationCall={handleNotificationCall}
                      />
                    </ExternalEntityGroupProvider>
                  } />
                  :
                  (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                }
              </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SingleExternalEntityGroupAdd